// extracted by mini-css-extract-plugin
export default {"aboutUsPage":"AboutUsPage_aboutUsPage__IcpQ7","aboutUsMini":"AboutUsPage_aboutUsMini__Ri9AZ"};